import InfoStep from '../ListingWizard/components/steps/InfoStep';
import ListingQualityScore from '../ListingWizard/components/ListingQualityScore';

const INFO = [
  {
    step: 1,
    title: "General Info",
    content: [
      "Let's start with the basics.",
      "Adding extra details helps the right person find the right horse.\n\n" +
      "If you need to change these details later, it's easy to come back and make edits."
    ]
  },
  {
    step: 2,
    title: "Location & Disciplines",
    content: [
      "Specify the location where the horse is currently residing. The primary location for " +
      "your organization will automatically be selected if one isn't provided. This can be " +
      "changed later.",
      "Select only the disciplines your horse has worked in or is well suited for."
    ]
  },
  {
    step: 3,
    title: "Video & Photos",
    content: [
      "The best videos are just a few minutes long, in good lighting, without heavy editing or loud music.",
      "The most important photo is the conformation shot from the side of the horse. Photos of the front, " +
      "rear legs, and a photo of the horse engaging in its discipline are helpful too.",
      "Image file types that can be uploaded here include JPEG, JPG, and PNG."
    ]
  },
  {
    step: 4,
    title: "Documents",
    content: [
      "You can add any documents you want here. Think of this as a storage folder for anything important the adopter might want to know.",
      "Document file types that can be uploaded here include JPEG, JPG, PNG, PDF, CSV, and DOCX."
    ]
  },
  {
    step: 5,
    title: "Basic Behavior Profile",
    content: [
      "Your horse has completed the Basic Behavior Profile. Make sure to select the " +
      "correct result and provide the evaluator's name and completion date.",
      "This helps the adopter understand where a horse is at in its training."
    ]
  },
  {
    step: 6,
    title: "Preview",
    content: [
      "Take a look at how your listing will appear in a search. " +
      "If everything looks good, make it live so someone can find their right horse!"
    ]
  }
];

export default function InfoBox() {
  return (
    <div className="info-box">
      <div className="steps">
        <ListingQualityScore/>
        {INFO.map(({step, title, content}) => (
          <InfoStep key={step} currentStep={step} title={title}>
            {content.map((paragraph, i) => (
              <div key={i} className="text-block">
                <p>{paragraph}</p>
              </div>
            ))}
          </InfoStep>
        ))}
      </div>
    </div>
  );
}
